export type JwtPayload = Record<string, unknown> & {
  exp?: number;
};

const decodeBase64Url = (value: string): string => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    '=',
  );

  return atob(padded);
};

export const decodeJwtPayload = <T extends JwtPayload = JwtPayload>(
  token: string,
): T | null => {
  try {
    const [, payload] = token.split('.');

    if (!payload) {
      return null;
    }

    return JSON.parse(decodeBase64Url(payload)) as T;
  } catch {
    return null;
  }
};

export const isJwtPayloadExpired = (
  payload: Pick<JwtPayload, 'exp'> | null,
): boolean => {
  if (!payload?.exp || typeof payload.exp !== 'number') {
    return true;
  }

  return payload.exp * 1000 < Date.now();
};
